const clientType = {
  SHIPPER: 1,
  PANDO_NETWORK: 2,
  TRANSPORTER: 3,
  CONSIGNEE: 4,
  NIMBUS_SUPER_ADMIN: 5,
  NIMBUS_USER: 6,
  FREIGHT_FORWARDER: 7,
  CLEARING_HOUSE_AGENT: 8,
  CONSIGNEE_USER: 9,
};

module.exports = {
  clientType,
};
